import { AppDispatch, AppThunk, AsyncAppThunk } from "store/store";
import { httpWrapper } from "../../utils/http";
import { SMS_API_BASE } from "../../constants";
import { handleError } from "errors/errors";
import {
  listPromotionMailTemplatesStart,
  listPromotionMailTemplatesSuccess,
  listPromotionMailTemplatesError,
  editPromotionMailTemplateStart,
  editPromotionMailTemplateSuccess,
  editPromotionMailTemplateError,
  getPromotionMailTemplateStart,
  getPromotionMailTemplateSuccess,
  getPromotionMailTemplateError,
} from "./PromotionMailTemplateSlice";
import {
  PromotionMailTemplate,
  PromotionMailTemplateUpdateForm,
} from "../../api/sms-api";
import i18n from "i18n";
import { showNotification } from "utils/notifications";

export const listPromotionMailTemplates = (): AppThunk => async (
  dispatch: AppDispatch
) => {
  dispatch(listPromotionMailTemplatesStart());
  try {
    const mailTemplates = await httpWrapper<Array<PromotionMailTemplate>>(
      "GET",
      `${SMS_API_BASE}/promotion_mail_template/list`,
      {}
    );
    dispatch(listPromotionMailTemplatesSuccess(mailTemplates));
  } catch (e) {
    handleError(e);
    dispatch(listPromotionMailTemplatesError(e));
  }
};

export const editPromotionMailTemplate = (
  id: string,
  params: PromotionMailTemplateUpdateForm
): AsyncAppThunk<void> => async (dispatch: AppDispatch) => {
  dispatch(editPromotionMailTemplateStart());
  try {
    await httpWrapper(
      "PATCH",
      `${SMS_API_BASE}/promotion_mail_template/update/${id}`,
      params
    );

    showNotification(i18n.t("mailTemplate.editSuccess"));
    dispatch(listPromotionMailTemplates());
    dispatch(editPromotionMailTemplateSuccess());
  } catch (e) {
    handleError(e);
    dispatch(editPromotionMailTemplateError(e));
  }
};

export const getPromotionMailTemplate = (id: string): AppThunk => async (
  dispatch: AppDispatch
) => {
  dispatch(getPromotionMailTemplateStart());
  try {
    const promotionMailTemplate = await httpWrapper<PromotionMailTemplate>(
      "GET",
      `${SMS_API_BASE}/promotion_mail_template/${id}`,
      {}
    );
    dispatch(getPromotionMailTemplateSuccess(promotionMailTemplate));
  } catch (e) {
    handleError(e);
    dispatch(getPromotionMailTemplateError(e));
  }
};
